/* AOS: optioneel via assets/css/aos.min.css + wp_enqueue; geen bundled import i.v.m. postcss-resolutie vanuit aos-pakket. */

function openBezichtigingWidget() {
  const widget = document.querySelector("[data-bezichtiging-widget]");
  if (!widget || widget.classList.contains("bezichtiging-widget--open")) {
    return;
  }

  widget.classList.add("bezichtiging-widget--open");

  const trigger = widget.querySelector(".bezichtiging-widget__trigger");
  const panel = widget.querySelector(".bezichtiging-widget__panel");
  const backdrop = widget.querySelector(".bezichtiging-widget__backdrop");

  if (trigger) {
    trigger.setAttribute("aria-expanded", "true");
  }
  if (panel) {
    panel.setAttribute("aria-hidden", "false");
  }
  if (backdrop) {
    backdrop.setAttribute("aria-hidden", "false");
  }

  document.documentElement.classList.add("no-scroll");
  document.body.classList.add("no-scroll");
}

function closeBezichtigingWidget() {
  const widget = document.querySelector("[data-bezichtiging-widget]");
  if (!widget || !widget.classList.contains("bezichtiging-widget--open")) {
    return;
  }

  widget.classList.remove("bezichtiging-widget--open");

  const trigger = widget.querySelector(".bezichtiging-widget__trigger");
  const panel = widget.querySelector(".bezichtiging-widget__panel");
  const backdrop = widget.querySelector(".bezichtiging-widget__backdrop");

  if (trigger) {
    trigger.setAttribute("aria-expanded", "false");
  }
  if (panel) {
    panel.setAttribute("aria-hidden", "true");
  }
  if (backdrop) {
    backdrop.setAttribute("aria-hidden", "true");
  }

  document.documentElement.classList.remove("no-scroll");
  document.body.classList.remove("no-scroll");
}

document.addEventListener("click", function (event) {
  const openTrigger = event.target.closest("[data-bezichtiging-open]");
  if (openTrigger) {
    event.preventDefault();
    openBezichtigingWidget();
    return;
  }

  if (event.target.closest("[data-bezichtiging-close]")) {
    event.preventDefault();
    closeBezichtigingWidget();
  }
});

document.addEventListener("keydown", function (event) {
  if (event.key === "Escape") {
    closeBezichtigingWidget();
  }
});

const shareButton = document.getElementById("sharebutton");
if (shareButton) {
  const title = shareButton.dataset.objecttitle;
  shareButton.addEventListener("click", async (e) => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: "Bekijk " + title,
          text: "Bekijk " + title + " aangeboden door Heeren Makelaars",
          url: window.location.href,
        });
      } catch (error) {
        console.error("Error sharing:", error);
      }
    } else {
      const shareBox = document.getElementById("sharebutton-dropdown");
      if (shareBox.classList.contains("show")) {
        shareBox.classList.remove("show");
      } else {
        shareBox.classList.add("show");
      }
    }
  });
}

window.addEventListener("load", function () {
  if (typeof AOS !== "undefined") {
    AOS.refresh();
  }
});
jQuery(function ($) {
  // Only top-level nav items: nested .menu-item handlers caused mouseleave when
  // moving into submenus, flickering navigation-active / overlay.
  const desktopNavMenuItems = $("#navitems .menu > .menu-item");
  const siteHeaderFront = $(".site-header");
  const nav = $("#desktopnav");
  const mobilenav = $("#mobilenav");
  const mobilenavitems = $(
    "#mobilenavitemscontainer .menu > .menu-item-has-children",
  );
  const navitems = $("#navitems");
  const searchbutt = $("#searchbutt");
  let popup = $("#objects-single-popup");
  let lastScroll = 0;
  const pagecontent = $(".page-content");
  const objectsmain = $("#objectsmain");
  const hamburger = $("#hamburger");
  const mobilenavitemscontainer = $("#mobilenavitemscontainer");

  $(document).on("click", "[data-language-switch-toggle]", function (e) {
    e.preventDefault();
    e.stopPropagation();
    const $toggle = $(this);
    const $root = $toggle.closest("[data-language-switch]");
    const panelId = $toggle.attr("aria-controls");
    const $panel = panelId ? $("#" + panelId) : $();
    if (!$panel.length) {
      return;
    }

    const wasOpen = $root.hasClass("is-open");

    $("[data-language-switch].is-open").not($root).removeClass("is-open");
    $("[data-language-switch-toggle]")
      .not($toggle)
      .attr("aria-expanded", "false");
    $("[data-language-switch-list]").not($panel).prop("hidden", true);

    if (wasOpen) {
      $root.removeClass("is-open");
      $toggle.attr("aria-expanded", "false");
      $panel.prop("hidden", true);
    } else {
      $root.addClass("is-open");
      $toggle.attr("aria-expanded", "true");
      $panel.prop("hidden", false);
    }
  });

  $(document).on("click", function () {
    $("[data-language-switch].is-open").removeClass("is-open");
    $("[data-language-switch-toggle]").attr("aria-expanded", "false");
    $("[data-language-switch-list]").prop("hidden", true);
  });

  $(document).on("keydown", function (e) {
    if (e.key !== "Escape") {
      return;
    }
    $("[data-language-switch].is-open").removeClass("is-open");
    $("[data-language-switch-toggle]").attr("aria-expanded", "false");
    $("[data-language-switch-list]").prop("hidden", true);
  });

  $(document).on("click", "[data-language-switch]", function (e) {
    e.stopPropagation();
  });

  searchbutt.click(function () {
    navitems.addClass("hide");
    $("#searchbar").addClass("show");
    $(this).addClass("hide");
    $("#closesearchbutt").addClass("show");
  });

  $("#closesearchbutt").click(function () {
    navitems.removeClass("hide");
    $("#searchbar").removeClass("show");
    $("#searchbutt").removeClass("hide");
    $("#closesearchbutt").removeClass("show");
  });

  const $citymarquee = $("#citymarquee");
  if ($citymarquee.length) {
    $citymarquee.on("init", function () {
      if (typeof AOS !== "undefined") {
        AOS.refresh();
      }
    });

    $citymarquee.slick({
      speed: 1500,
      autoplay: true,
      autoplaySpeed: 0,
      centerMode: true,
      cssEase: "linear",
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      infinite: true,
      initialSlide: 0,
      arrows: false,
      buttons: false,
    });
  }

  $("#open_filters")
    .find("button")
    .click(function () {
      $("body, html").toggleClass("no-scroll");
      $("#filter_form").toggleClass("open");
    });

  $("#mobile_filterclose").click(function () {
    $("body, html").removeClass("no-scroll");
    $(document).scrollTop();
    $("#filter_form").removeClass("open");
  });

  hamburger.click(function () {
    mobilenavitemscontainer.toggleClass("open");
    $(".hamburger").toggleClass("open");
  });

  mobilenavitems.each(function () {
    $(this).children("a").attr("href", "#!");
    $(this).children(".sub-menu").slideUp();
  });

  mobilenavitems.click(function () {
    $(this).toggleClass("active");
    $(this).children(".sub-menu").slideToggle();
    mobilenavitems.not($(this)).removeClass("active");
    mobilenavitems.not($(this)).children(".sub-menu").slideUp();
  });

  if ($(document).scrollTop() > pagecontent[0].offsetTop) {
    nav.addClass("bg");
  } else {
    nav.removeClass("bg");
  }

  function hydrateGalleryMedia(root) {
    $(root)
      .find("source[data-lazy]")
      .each(function () {
        const lazy = this.getAttribute("data-lazy");
        if (lazy && !this.getAttribute("srcset")) {
          this.setAttribute("srcset", lazy);
        }
      });
    $(root)
      .find("img[data-lazy]")
      .each(function () {
        const src = this.getAttribute("src") || "";
        if (src.indexOf("data:") === 0 || src === "") {
          this.src = this.getAttribute("data-lazy");
        }
      });
    $(root)
      .find("iframe[data-src]")
      .each(function () {
        const src = this.getAttribute("src") || "";
        if (src === "" || src === "about:blank") {
          this.src = this.getAttribute("data-src");
        }
      });
  }

  function ensureObjectGallerySliders() {
    const $images = $("#galleryimageslider");
    if ($images.length && !$images.hasClass("slick-initialized")) {
      $images.slick({
        slidesToShow: 1,
        prevArrow: ".gallery-slider-prev",
        nextArrow: ".gallery-slider-next",
        infinite: true,
        lazyLoad: "ondemand",
      });
    }

    const $blueprints = $("#galleryblueprintslider");
    if ($blueprints.length && !$blueprints.hasClass("slick-initialized")) {
      $blueprints.slick({
        slidesToShow: 1,
        arrows: false,
        animation: false,
        speed: 0,
        lazyLoad: "ondemand",
      });
    }

    const $videos = $("#galleryvideoslider");
    if ($videos.length && !$videos.hasClass("slick-initialized")) {
      $videos.slick({
        slidesToShow: 1,
        arrows: false,
        animation: false,
        speed: 0,
      });
      hydrateGalleryMedia($videos);
    }
  }

  desktopNavMenuItems.hover(
    () => {
      $(".navigation-overlay").addClass("show");
      if (siteHeaderFront.length > 0) {
        siteHeaderFront.addClass("navigation-active");
      }
    },
    () => {
      $(".navigation-overlay").removeClass("show");
      siteHeaderFront.removeClass("navigation-active");
    },
  );

  $(".review-slider").slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    prevArrow: ".review-slider-button__prev",
    nextArrow: ".review-slider-button__next",
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    dots: true,
    appendDots: ".review-slider-counter",
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
    customPaging: function (slider, i) {
      return (
        '<span class="fw_bold">' + (i + 1) + "</span>" + "/" + slider.slideCount
      );
    },
  });


  $(document).scroll(function () {
    let st = $(this).scrollTop();
    if ($(document).scrollTop() > pagecontent[0].offsetTop) {
      nav.addClass("bg");
      mobilenav.addClass("bg");
    } else {
      nav.removeClass("bg");
      mobilenav.addClass("bg");
    }
  });


  $(".network-slider").slick({
    speed: 5000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: true,
    useTransform: true,
    cssEase: "linear",
    slidesToShow: 3,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    arrows: false,
    pauseOnHover: false,
    buttons: false,
    swipe: false,
    initialSlide: [1, 3, 5][([1, 3, 5].length * Math.random()) | 0],
    responsive: [
      {
        breakpoint: 600,
        settings: {
          speed: 5000,
          autoplay: 1000,
        },
      },
    ],
  });

  $(".objects-single-header-action").on("click", function (event) {
    let formtype = $(this).data("type") || event.target.dataset.type;

    let popup = $("#objects-single-popup");
    let viewing = $("#objects-single-form-viewing");
    let react = $("#objects-single-form-comment");
    let taxation = $("#objects-single-form-taxation");
    let bid = $("#objects-single-form-bid");
    let contact = $("#objects-single-form-contact");
    $([document.documentElement, document.body]).addClass("no-scroll");

    switch (formtype) {
      case "react":
        bid.hide();
        viewing.hide();
        taxation.hide();
        contact.hide();
        react.show();
        popup.removeClass("hide");
        popup.addClass("show");
        break;

      case "viewing":
        bid.hide();
        react.hide();
        taxation.hide();
        contact.hide();
        viewing.show();
        popup.removeClass("hide");
        popup.addClass("show");
        break;

      case "taxation":
        bid.hide();
        viewing.hide();
        react.hide();
        contact.hide();
        taxation.show();
        popup.removeClass("hide");
        popup.addClass("show");
        break;

      case "bid":
        react.hide();
        viewing.hide();
        taxation.hide();
        contact.hide();
        bid.show();
        popup.removeClass("hide");
        popup.addClass("show");
        break;

      case "contact":
        react.hide();
        viewing.hide();
        taxation.hide();
        bid.hide();
        contact.show();

        popup.removeClass("hide");
        popup.addClass("show");
        break;
    }
  });

  $("#formclosebutton").on("click", function () {
    popup.addClass("hide");
    $([document.documentElement, document.body]).removeClass("no-scroll");
  });

  $("#galleryblueprintslider").on(
    "afterChange",
    function (event, slick, currentSlide) {
      $("#blueprintselector").val(parseInt(currentSlide));
    },
  );

  $("#galleryvideoslider").on(
    "afterChange",
    function (event, slick, currentSlide) {
      $("#videoselector").val(parseInt(currentSlide));
    },
  );

  $(document).on("keydown", function (event) {
    if (event.key === "Escape") {
      popup.addClass("hide");
      $("#all").hide();
      $("#videos").hide();
      $("#blueprints").hide();
      $("#images").hide();
      objectsgallery.addClass("hide");
      objectsgallery.removeClass("show");
      $("html").removeClass("no-scroll");
      $("body").removeClass("no-scroll");
      // $([document.documentElement, document.body]).animate({
      //     scrollTop: lastScroll
      // }, 500);
    }

    if (event.originalEvent.keyCode == 37) {
      if ($("#videos").is(":visible") && $("#galleryvideoslider").hasClass("slick-initialized")) {
        if ($("#galleryvideoslider").slick("slickCurrentSlide") > 0) {
          $("#galleryvideoslider").slick("slickPrev");
          $("#videoselector").val(
            $("#galleryvideoslider").slick("slickCurrentSlide"),
          );
        }
      }
      if ($("#blueprints").is(":visible") && $("#galleryblueprintslider").hasClass("slick-initialized")) {
        if ($("#galleryblueprintslider").slick("slickCurrentSlide") > 0) {
          $("#galleryblueprintslider").slick("slickPrev");
          $("#blueprintselector").val(
            $("#galleryblueprintslider").slick("slickCurrentSlide"),
          );
        }
      }
      if ($("#images").is(":visible") && $("#galleryimageslider").hasClass("slick-initialized")) {
        $("#galleryimageslider").slick("slickPrev");
      }
    }

    if (event.keyCode == 39) {
      if ($("#videos").is(":visible") && $("#galleryvideoslider").hasClass("slick-initialized")) {
        const vidslider = $("#galleryvideoslider").slick("getSlick");
        if (vidslider.currentSlide < vidslider.slideCount - 1) {
          $("#galleryvideoslider").slick("slickNext");
          $("#videoselector").val(vidslider.currentSlide);
        }
      }

      if ($("#blueprints").is(":visible") && $("#galleryblueprintslider").hasClass("slick-initialized")) {
        const bpslider = $("#galleryblueprintslider").slick("getSlick");
        if (bpslider.currentSlide < bpslider.slideCount - 1) {
          $("#galleryblueprintslider").slick("slickNext");
          $("#blueprintselector").val(bpslider.currentSlide);
        }
      }

      if ($("#images").is(":visible") && $("#galleryimageslider").hasClass("slick-initialized")) {
        $("#galleryimageslider").slick("slickNext");
      }
    }
  });

  let objectsgallery = $("#objects-media-gallery");
  let mediabutton = $(".objects-single-media-button");
  let galleryclosebutton = $("#galleryclosebutton");
  let formtype = null;

  mediabutton.on("click", function (event) {
    formtype = event.currentTarget.dataset.type;
    $([document.documentElement, document.body]).addClass("no-scroll");
    ensureObjectGallerySliders();
    if (formtype === "all") {
      hydrateGalleryMedia("#all");
    }
    $("#galleryimageslider").slick("setOption", { speed: 1 });
    $("#galleryimageslider").slick("refresh");
    $("#galleryimageslider").slick("setOption", { speed: 500 });
    $("#galleryblueprintslider").slick("setOption", { speed: 1 });
    $("#galleryblueprintslider").slick("refresh");
    $("#galleryvideoslider").slick("setOption", { speed: 1 });
    $("#galleryvideoslider").slick("refresh");
    $("#" + formtype).show();
    objectsgallery.removeClass("hide");
    objectsgallery.addClass("show");
  });

  $(".objects-single-header-image").on("click", function (event) {
    $([document.documentElement, document.body]).addClass("no-scroll");
    ensureObjectGallerySliders();
    $("#galleryimageslider").slick("setOption", { speed: 1 });
    $("#galleryimageslider").slick("slickGoTo", 0, false);
    $("#galleryimageslider").slick("refresh");
    $("#galleryimageslider").slick("setOption", { speed: 500 });
    $("#galleryblueprintslider").slick("refresh");
    $("#galleryvideoslider").slick("refresh");
    $("#images").show();
    objectsgallery.removeClass("hide");
    objectsgallery.addClass("show");
  });

  $(".objects-single-content-images-top").on("click", function (event) {
    $([document.documentElement, document.body]).addClass("no-scroll");
    ensureObjectGallerySliders();
    $("#galleryimageslider").slick("setOption", { speed: 1 });
    $("#galleryimageslider").slick("slickGoTo", 1, false);
    $("#galleryimageslider").slick("refresh");
    $("#galleryimageslider").slick("setOption", { speed: 500 });
    $("#galleryblueprintslider").slick("refresh");
    $("#galleryvideoslider").slick("refresh");
    $("#images").show();
    objectsgallery.removeClass("hide");
    objectsgallery.addClass("show");
  });

  $(".objects-single-content-images-bottom").on("click", function (event) {
    const index = event.target.dataset.index;
    $([document.documentElement, document.body]).addClass("no-scroll");
    ensureObjectGallerySliders();
    $("#galleryimageslider").slick("setOption", { speed: 1 });
    $("#galleryimageslider").slick("slickGoTo", index, false);
    $("#galleryimageslider").slick("refresh");
    $("#galleryimageslider").slick("setOption", { speed: 500 });
    $("#galleryblueprintslider").slick("refresh");
    $("#galleryvideoslider").slick("refresh");
    $("#images").show();
    objectsgallery.removeClass("hide");
    objectsgallery.addClass("show");
  });

  galleryclosebutton.on("click", function () {
    $([document.documentElement, document.body]).removeClass("no-scroll");
    $("#all").hide();
    $("#videos").hide();
    $("#blueprints").hide();
    $("#images").hide();

    objectsgallery.addClass("hide");
    objectsgallery.removeClass("show");
  });

  $("#blueprintselector").on("change", function (event) {
    let currenttarget = event.currentTarget;
    $("#galleryblueprintslider").slick("slickGoTo", currenttarget.value, false);
  });

  $("#videoselector").on("change", function (event) {
    let currenttarget = event.currentTarget;
    $("#galleryvideoslider").slick("slickGoTo", currenttarget.value, false);
  });

  $(".objects-single-gallery-imagegrid-inner-image").on(
    "click",
    function (event) {
      const currenttarget = event.currentTarget;
      const type = currenttarget.dataset.type;
      const index = currenttarget.dataset.index;
      ensureObjectGallerySliders();

      switch (type) {
        case "images":
          $("#all").hide();
          $("#videos").hide();
          $("#blueprints").hide();
          $("#images").show();
          $("#galleryimageslider").slick("slickGoTo", parseInt(index) + 1);
          break;
        case "blueprints":
          $("#all").hide();
          $("#videos").hide();
          $("#images").hide();
          $("#blueprints").show();
          $("#galleryblueprintslider").slick("slickGoTo", parseInt(index));
          $("#blueprintselector").val(parseInt(index));
          break;
        case "videos":
          $("#all").hide();
          $("#blueprints").hide();
          $("#images").hide();
          $("#videos").show();
          $("#galleryvideoslider").slick("slickGoTo", parseInt(index));
          $("#videoselector").val(parseInt(index));
          break;
      }
    },
  );

  function shouldLoadFrontHeroVideo() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      return false;
    }

    const connection =
      navigator.connection ||
      navigator.mozConnection ||
      navigator.webkitConnection;
    if (connection && connection.saveData) {
      return false;
    }

    return true;
  }

  function playFrontHeroVideo(videoEl) {
    if (!videoEl || typeof videoEl.play !== "function") {
      return;
    }

    videoEl.muted = true;
    videoEl.defaultMuted = true;
    videoEl.playsInline = true;
    videoEl.setAttribute("playsinline", "");
    videoEl.setAttribute("webkit-playsinline", "");

    const playPromise = videoEl.play();
    if (playPromise && typeof playPromise.catch === "function") {
      playPromise.catch(function () {});
    }
  }

  function isFrontHeroVisible(videoEl) {
    if (!videoEl) {
      return false;
    }

    const hero = videoEl.closest(".frontpage-hero");
    if (!hero) {
      return false;
    }

    return window.getComputedStyle(hero).display !== "none";
  }

  function loadFrontHeroVideo() {
    const $video = $("#headervideo");
    const src = $video.data("src");
    if ($video.length && src && shouldLoadFrontHeroVideo()) {
      const videoEl = $video.get(0);

      const start = function () {
        if (!$video.attr("src")) {
          $video.attr("src", String(src));
        }

        if (isFrontHeroVisible(videoEl)) {
          playFrontHeroVideo(videoEl);
        }
      };

      const playWhenVisible = function () {
        if (isFrontHeroVisible(videoEl)) {
          playFrontHeroVideo(videoEl);
        }
      };

      if (typeof window.requestIdleCallback === "function") {
        window.requestIdleCallback(start, { timeout: 2000 });
      } else {
        window.setTimeout(start, 1);
      }

      document.addEventListener(
        "click",
        function (event) {
          if (!event.target.closest("a.frontpage-choice__title")) {
            return;
          }
          window.setTimeout(playWhenVisible, 0);
        },
        true,
      );

      if (typeof MutationObserver === "function") {
        const observer = new MutationObserver(playWhenVisible);
        observer.observe(document.documentElement, {
          attributes: true,
          attributeFilter: ["class"],
        });
      }
    }

    setTimeout(function () {
      $("#headertext")
        .children("p")
        .each(function () {
          $(this).toggleClass("show");
        });
    }, 3000);
  }

  if ($("#headertext").length) {
    loadFrontHeroVideo();
  }

  function initMap($el) {
    // Find marker elements within map.
    var $markers = $el.find(".marker");

    // Create gerenic map.
    var mapArgs = {
      zoom: $el.data("zoom") || 16,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      styles: [
        {
          featureType: "all",
          elementType: "labels",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "administrative",
          elementType: "all",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "administrative",
          elementType: "labels",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "administrative",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#444444",
            },
          ],
        },
        {
          featureType: "administrative.country",
          elementType: "labels",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "administrative.province",
          elementType: "labels",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "administrative.locality",
          elementType: "labels",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "administrative.neighborhood",
          elementType: "labels",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "administrative.land_parcel",
          elementType: "labels",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "landscape",
          elementType: "all",
          stylers: [
            {
              color: "#f2f2f2",
            },
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "landscape",
          elementType: "geometry",
          stylers: [
            {
              visibility: "on",
            },
            {
              gamma: "0.00",
            },
          ],
        },
        {
          featureType: "landscape",
          elementType: "labels",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "landscape.man_made",
          elementType: "geometry",
          stylers: [
            {
              visibility: "on",
            },
          ],
        },
        {
          featureType: "landscape.man_made",
          elementType: "labels",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "landscape.natural",
          elementType: "geometry",
          stylers: [
            {
              visibility: "on",
            },
          ],
        },
        {
          featureType: "landscape.natural.landcover",
          elementType: "labels",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "poi",
          elementType: "labels",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "poi",
          elementType: "labels.text",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "poi.attraction",
          elementType: "labels",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "poi.business",
          elementType: "geometry",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "poi.business",
          elementType: "labels",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "poi.government",
          elementType: "labels",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "poi.medical",
          elementType: "labels",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "poi.park",
          elementType: "geometry",
          stylers: [
            {
              color: "#ffffff",
            },
          ],
        },
        {
          featureType: "poi.place_of_worship",
          elementType: "labels",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "poi.school",
          elementType: "labels",
          stylers: [
            {
              visibility: "off",
            },
            {
              gamma: "1",
            },
            {
              lightness: "0",
            },
          ],
        },
        {
          featureType: "poi.sports_complex",
          elementType: "labels",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "road",
          elementType: "all",
          stylers: [
            {
              saturation: -100,
            },
            {
              lightness: "100",
            },
            {
              visibility: "on",
            },
            {
              gamma: "1.0",
            },
          ],
        },
        {
          featureType: "road",
          elementType: "geometry",
          stylers: [
            {
              visibility: "on",
            },
          ],
        },
        {
          featureType: "road",
          elementType: "geometry.fill",
          stylers: [
            {
              visibility: "on",
            },
          ],
        },
        {
          featureType: "road",
          elementType: "geometry.stroke",
          stylers: [
            {
              visibility: "on",
            },
          ],
        },
        {
          featureType: "road",
          elementType: "labels",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "road",
          elementType: "labels.text",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "road",
          elementType: "labels.text.fill",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "road",
          elementType: "labels.text.stroke",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "road",
          elementType: "labels.icon",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "road.highway",
          elementType: "all",
          stylers: [
            {
              visibility: "on",
            },
          ],
        },
        {
          featureType: "road.highway",
          elementType: "labels",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "road.arterial",
          elementType: "labels",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "road.arterial",
          elementType: "labels.icon",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "road.local",
          elementType: "labels",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "road.local",
          elementType: "labels.icon",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "transit",
          elementType: "all",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "water",
          elementType: "all",
          stylers: [
            {
              color: "#b2daee",
            },
            {
              visibility: "on",
            },
          ],
        },
        {
          featureType: "water",
          elementType: "labels",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
      ],
    };
    var map = new google.maps.Map($el[0], mapArgs);

    // Add markers.
    map.markers = [];
    $markers.each(function () {
      initMarker($(this), map);
    });

    // Center map based on markers.
    centerMap(map);

    // Return map instance.
    return map;
  }

  function initMarker($marker, map) {
    // Get position from marker.
    var lat = $marker.data("lat");
    var lng = $marker.data("lng");
    var icon = $marker.data("icon");

    var latLng = {
      lat: parseFloat(lat),
      lng: parseFloat(lng),
    };

    // Create marker instance.
    var marker = new google.maps.Marker({
      position: latLng,
      map: map,
      icon: icon,
    });

    // Append to reference for later use.
    map.markers.push(marker);

    if ($marker.data("type") == "clickable") {
      google.maps.event.addListener(marker, "click", function () {
        locationslider.slick("slickGoTo", index);
      });
    }
  }

  function centerMap(map) {
    // Create map boundaries from all map markers.
    var bounds = new google.maps.LatLngBounds();
    map.markers.forEach(function (marker) {
      bounds.extend({
        lat: marker.position.lat(),
        lng: marker.position.lng(),
      });
    });

    // Case: Single marker.
    if (map.markers.length == 1) {
      map.setCenter(bounds.getCenter());

      // Case: Multiple markers.
    } else {
      map.fitBounds(bounds);
    }
  }

  $(document).ready(function () {
    $(".acf-map").each(function () {
      var map = initMap($(this));
    });
  });
});
